export default __webpack_public_path__ + "static/media/organization-icon.f59a1389.svg";